import { ROUTE_TO_FEATURE_NAME } from 'shared/constants/routes';

export default function checkFeatureFlag(usersStore, featureName, enabledUserTypes) {
  if (getTempSuperAdminFeatureFlag() === featureName) {
    return true;
  }
  if (ROUTE_TO_FEATURE_NAME[window.location.pathname] === featureName) {
    return true;
  }
  const currAuthUser = (usersStore.usersModel.users || []).find(({ userKey }) => userKey === usersStore.authUserKey);
  const authUserType = currAuthUser ? currAuthUser.userType : null;
  const accountFeatures = usersStore.getCurrentDisplayedAccountFeatures(usersStore.currDispUserAccountKey);
  const enabledUserTypesArr = enabledUserTypes || [];
  if (enabledUserTypesArr.includes(authUserType) || (accountFeatures || []).includes(featureName)) {
    return true;
  }
  return false;
}

export function getTempSuperAdminFeatureFlag() {
  return window.location.href ? new URL(window.location.href).searchParams.get('temp-feature-flag') : null;
}
